/* global axios */
import ApiClient from './ApiClient';

class HandoffRulesAPI extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true });
  }

  scopedUrl(agentBotId) {
    return `${this.url}/${agentBotId}/handoff_rules`;
  }

  index(agentBotId) {
    return axios.get(this.scopedUrl(agentBotId));
  }

  confirm(agentBotId, id, data = {}) {
    return axios.post(`${this.scopedUrl(agentBotId)}/${id}/confirm`, {
      handoff_rule: data,
    });
  }

  dismiss(agentBotId, id) {
    return axios.post(`${this.scopedUrl(agentBotId)}/${id}/dismiss`);
  }
}

export default new HandoffRulesAPI();
